import { useQuery, NetworkStatus } from "@apollo/client";
import { GetDentistsDocument } from "../../gql/generated/graphql";

const DEFAULT_PAGE_SIZE = 20;

type UseGetDentistsArgs = {
  search?: string;
  pageSize?: number;
};

export const useGetDentists = ({
  search,
  pageSize = DEFAULT_PAGE_SIZE,
}: UseGetDentistsArgs = {}) => {
  const { data, loading, fetchMore, networkStatus } = useQuery(
    GetDentistsDocument,
    {
      variables: { search, pageSize },
      notifyOnNetworkStatusChange: true,
    }
  );

  const pageInfo = data?.getDentists.pageInfo;
  const isFetchingMore = networkStatus === NetworkStatus.fetchMore;

  const loadMore = async () => {
    if (!pageInfo?.hasNextPage || !pageInfo.endCursor || isFetchingMore) {
      return;
    }

    await fetchMore({
      variables: {
        search,
        pageSize,
        cursor: pageInfo.endCursor,
      },
      updateQuery: (previous, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previous;
        }

        return {
          ...fetchMoreResult,
          getDentists: {
            ...fetchMoreResult.getDentists,
            nodes: [
              ...previous.getDentists.nodes,
              ...fetchMoreResult.getDentists.nodes,
            ],
          },
        };
      },
    });
  };

  return {
    dentists: data?.getDentists.nodes ?? [],
    hasNextPage: pageInfo?.hasNextPage ?? false,
    loading,
    isFetchingMore,
    loadMore,
  };
};
